module.exports = "<h2>{{'menu.catalog.products.remove.title' | translate}}</h2>\n\n<p>\n  {{description}}<br/>\n  {{'menu.catalog.products.remove.body.notice' | translate}}\n</p>\n\n<div class=\"action-footer\">\n  <button class=\"button secondary\" ng-click=\"cancel()\">{{'common.buttons.cancel' | translate}}</button>\n  <button class=\"button\" ng-click=\"remove()\">{{'common.buttons.remove' | translate}}</button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/menu/catalog/catalog.remove.modal.html
 ** module id = 600
 ** module chunks = 0
 **/